import { render, staticRenderFns } from "./score-sort.vue?vue&type=template&id=760899ea&scoped=true"
import script from "./score-sort.vue?vue&type=script&lang=js"
export * from "./score-sort.vue?vue&type=script&lang=js"
import style0 from "./score-sort.vue?vue&type=style&index=0&id=760899ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760899ea",
  null
  
)

export default component.exports